import AppMain from "../../components/layout/AppMain";

const DataManagementRoutes = {
  path: "/manage",
  component: AppMain,
  redirect: "/manage/data-points",
  name: "DataManagement",
  meta: {
    title: "Manage Data",
    icon: "folder-open",
    permissions: ["view data"],
  },
  children: [
    {
      path: "data-requests",
      component: () => import("@/views/manage-data/data-requests/List"),
      name: "DataRequests",
      meta: { title: "Data Requests" },
    },
    {
      path: "data-points",
      component: () => import("@/views/manage-data/data-points/List"),
      name: "DataPoints",
      meta: { title: "Data Points Management" },
    },
  ],
};

export default DataManagementRoutes;
